<template>
  <div class="page-bg">
    <div class="card search-card">
      <!-- 搜索区域 -->
      <el-form size="small" label-width="100px" class="margin15-tb" @submit.native.prevent>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="公司名称">
              <el-select v-model="search.companyId" placeholder="请选择公司" clearable @change="onSearchCompanyChange" filterable style="width: 100%">
                <el-option v-for="item in searchCompanyList" :key="item.id" :label="item.companyName" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="策略组名称">
              <el-select v-model="search.groupId" placeholder="请选择策略组" clearable filterable style="width: 100%">
                <el-option v-for="item in searchGroupList" :key="item.id" :label="item.groupName" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6" style="display:flex;justify-content:flex-end;align-items:center;margin-left:-60px;">
            <el-button type="primary" @click="handleSearch" style="margin-right:8px;">
              <i class="el-icon-search" style="margin-right:4px;"></i>搜索
            </el-button>
            <el-button @click="handleReset">
              <i class="el-icon-refresh" style="margin-right:4px;"></i>重置
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="card table-card">
      <!-- 添加按钮 -->
      <div class="table-header">
        <el-button type="primary" icon="el-icon-plus" size="small" @click="handleAdd">添加配置</el-button>
      </div>

      <!-- 表格区域 -->
      <el-table
        :data="list"
        v-loading="loading"
        size="small"
        style="width:100%"
        :header-cell-style="headerCellStyle"
        :cell-style="cellStyle"
      >
        <el-table-column prop="companyName" label="复制公司" align="center" />
        <el-table-column prop="targetCompanyName" label="跟进公司" align="center" />
        <el-table-column prop="groupName" label="策略组" align="center" />
        <el-table-column prop="targetGroupName" label="跟进策略组" align="center" />
        <el-table-column prop="urgeStatusText" label="催收状态" align="center" />
        <el-table-column prop="caseStatusText" label="案件状态" align="center" />
        <el-table-column prop="selfContactStatusText" label="本人联系状态" align="center" />
        <el-table-column prop="overdueDates" label="逾期天数" align="center" />
        <el-table-column prop="overdueAmount" label="逾期总额" align="center" />
        <el-table-column label="进件时间" align="center">
          <template slot-scope="scope">
            <span>{{ formatCreateRange(scope.row.startCreateTime, scope.row.endCreateTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="timingTime" label="跟进时间" align="center" />
        <el-table-column prop="holidayText" label="特殊时间段" align="center" />
        <el-table-column prop="param" label="参数" align="center" />
        <el-table-column prop="createTime" label="创建时间" align="center" />
        <el-table-column prop="isOpen" label="是否开启配置" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.isOpen"
              :active-value="true"
              :inactive-value="false"
              @change="val => handleStatusChange(scope.row, val)"
            />
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleEdit(scope.row)">
              <i class="el-icon-edit" style="margin-right:4px;"></i>编辑
            </el-button>
            <el-button type="text" size="small" style="color: red;" @click="handleDelete(scope.row)">
              <i class="el-icon-delete" style="margin-right:4px;"></i>删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        style="margin-top: 16px; text-align: center"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :page-size="pageSize"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        @current-change="handlePageChange"
        @size-change="handleSizeChange"
      />
    </div>

    <!-- 添加/编辑弹窗 -->
    <el-dialog title="添加配置" :visible.sync="dialogVisible" width="780px" @close="resetDialog" custom-class="center-dialog">
      <el-form :model="form" label-width="110px" label-position="left" :rules="rules" ref="formRef" style="margin-top:10px;">
        <!-- 基础：公司/策略组/目标公司/目标策略组/目标用户 -->
        <el-row :gutter="8">
          <el-col :span="12">
            <el-form-item label="公司" prop="companyId" :required="true">
              <el-select
                v-model="form.companyId"
                placeholder="请选择公司"
                clearable
                @change="onCompanyChange"
                :disabled="isEdit"
                filterable
                style="width:220px"
              >
                <el-option v-for="item in companyList" :key="item.id" :label="item.companyName" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="策略组" prop="groupId" :required="true">
              <el-select
                v-model="form.groupId"
                placeholder="请选择策略组"
                clearable
                :disabled="isEdit"
                filterable
                style="width:220px"
              >
                <el-option v-for="item in groupList" :key="item.id" :label="item.groupName" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="8">
          <el-col :span="12">
            <el-form-item label="跟进公司" prop="targetCompanyId" :required="true">
              <el-select
                v-model="form.targetCompanyId"
                placeholder="请选择跟进公司"
                clearable
                @change="onTargetCompanyChange"
                filterable
                style="width:220px"
              >
                <el-option v-for="item in companyList" :key="item.id" :label="item.companyName" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="跟进策略组" prop="targetGroupId">
              <el-select
                v-model="form.targetGroupId"
                placeholder="请选择跟进策略组"
                clearable
                filterable
                style="width:220px"
              >
                <el-option v-for="item in targetGroupList" :key="item.id" :label="item.groupName" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 业务字段：催收状态/案件状态/本人联系状态/逾期 -->
        <el-row :gutter="8">
          <el-col :span="12">
            <el-form-item label="案件状态">
              <el-select
                v-model="form.caseStatus"
                multiple
                collapse-tags
                clearable
                placeholder="请选择案件状态"
                style="width:220px"
              >
                <el-option v-for="item in caseStatusOptions" :key="item.modelCode" :label="item.modelName" :value="item.modelCode" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="催收状态" prop="urgeStatus">
              <el-select
                v-model="form.urgeStatus"
                multiple
                collapse-tags
                clearable
                placeholder="请选择催收状态"
                style="width:220px"
              >
                <el-option v-for="item in urgeStatusOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="8">
          <el-col :span="24">
            <div class="double-field">
              <el-form-item label="逾期天数" class="flex-form-item">
              <div class="range-input">
                <el-select
                  v-model="form.overdueDatesLogic"
                  placeholder="选择逻辑"
                  clearable
                  style="width:150px"
                  @change="val => handleLogicChange('overdueDates', val)"
                >
                  <el-option v-for="item in numberLogicOptions" :key="item.code" :label="item.label" :value="item.code" />
                </el-select>
                <template v-if="isRangeLogic(form.overdueDatesLogic)">
                  <el-input-number
                    v-model="form.overdueDatesStart"
                    :min="0"
                    :controls="false"
                    placeholder="开始值"
                    style="width:120px"
                  />
                  <span class="range-separator">至</span>
                  <el-input-number
                    v-model="form.overdueDatesEnd"
                    :min="0"
                    :controls="false"
                    placeholder="结束值"
                    style="width:120px"
                  />
                </template>
                <el-input-number
                  v-else
                  v-model="form.overdueDatesValue"
                  :min="0"
                  :controls="false"
                  placeholder="请输入数值"
                  style="width:220px"
                  :disabled="!form.overdueDatesLogic"
                />
              </div>
              </el-form-item>
              <el-form-item label="逾期总额" class="flex-form-item">
              <div class="range-input">
                <el-select
                  v-model="form.overdueAmountLogic"
                  placeholder="选择逻辑"
                  clearable
                  style="width:150px"
                  @change="val => handleLogicChange('overdueAmount', val)"
                >
                  <el-option v-for="item in numberLogicOptions" :key="item.code" :label="item.label" :value="item.code" />
                </el-select>
                <template v-if="isRangeLogic(form.overdueAmountLogic)">
                  <el-input-number
                    v-model="form.overdueAmountStart"
                    :min="0"
                    :controls="false"
                    :precision="2"
                    placeholder="最小值"
                    style="width:120px"
                  />
                  <span class="range-separator">至</span>
                  <el-input-number
                    v-model="form.overdueAmountEnd"
                    :min="0"
                    :controls="false"
                    :precision="2"
                    placeholder="最大值"
                    style="width:120px"
                  />
                </template>
                <el-input-number
                  v-else
                  v-model="form.overdueAmountValue"
                  :min="0"
                  :controls="false"
                  :precision="2"
                  placeholder="请输入金额"
                  style="width:220px"
                  :disabled="!form.overdueAmountLogic"
                />
              </div>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="8">
          <el-col :span="12">
            <el-form-item label="本人状态">
              <el-select
                v-model="form.selfContactStatus"
                multiple
                collapse-tags
                clearable
                placeholder="请选择本人联系状态"
                filterable
                style="width:220px"
              >
                <el-option v-for="item in selfContactStatusOptions" :key="item.value || item" :label="item.label || item" :value="item.value || item" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="目标用户" prop="targetUserId">
              <el-select v-model="form.targetUserId" placeholder="请选择目标用户" clearable filterable style="width:220px">
                <el-option v-for="item in targetUserList" :key="item.id" :label="item.userName" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 进件时间：起止分钟级 -->
        <el-row :gutter="8">
          <el-col :span="24">
            <el-form-item label="进件时间">
              <el-time-picker
                v-model="form.startCreateTime"
                value-format="HH:mm:ss"
                format="HH:mm"
                clearable
                placeholder="开始时间"
                style="width:200px;margin-right:8px;"
              />
              <span style="margin:0 8px;">-</span>
              <el-time-picker
                v-model="form.endCreateTime"
                value-format="HH:mm:ss"
                format="HH:mm"
                clearable
                placeholder="结束时间"
                style="width:200px;"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="8">
          <el-col :span="24">
            <el-form-item label="参数param">
              <div class="range-input param-inline">
                <el-select
                  v-model="form.paramKey"
                  placeholder="选择参数"
                  clearable
                >
                  <el-option
                    v-for="n in 15"
                    :key="`param${n}`"
                    :label="`param${n}`"
                    :value="`param${n}`"
                  />
                </el-select>
                <el-select
                  v-model="form.paramLogic"
                  placeholder="选择逻辑"
                  clearable
                  @change="handleParamLogicChange"
                >
                  <el-option
                    v-for="item in characterLogicOptions"
                    :key="item.code"
                    :label="item.label"
                    :value="item.code"
                  />
                </el-select>
                <el-input
                  v-model="form.param"
                  :disabled="!form.paramLogic"
                  clearable
                  placeholder="请输入参数值"
                />
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 跟进时间 -->
        <el-row :gutter="8">
          <el-col :span="12">
            <el-form-item label="跟进时间" prop="timingTime">
              <el-time-picker
                v-model="form.timingTime"
                value-format="HH:mm:ss"
                format="HH:mm:ss"
                clearable
                placeholder="请选择时间"
                style="width:220px"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否开启配置">
              <el-switch v-model="form.isOpen" :active-value="true" :inactive-value="false" />
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 特殊时间段选择 -->
        <el-row :gutter="8">
          <el-col :span="24">
            <el-form-item label="特殊时间段">
              <el-checkbox-group v-model="form.holiday">
                <el-checkbox :label="0">工作日</el-checkbox>
                <el-checkbox :label="1">周末</el-checkbox>
                <el-checkbox :label="2">节假日</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <div class="dialog-footer-center">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleDialogConfirm">确认</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
const SINGLE_VALUE_LOGIC_OPERATOR_MAP = {
  '5': '>',
  '6': '=',
  '7': '<',
  '8': '>=',
  '9': '<=',
  '10': '!='
};
const RANGE_LOGIC_BRACKETS_MAP = {
  '11': ['[', ')'],
  '12': ['(', ']'],
  '13': ['(', ')'],
  '14': ['[', ']']
};
const BRACKETS_TO_LOGIC = {
  '[)': '11',
  '(]': '12',
  '()': '13',
  '[]': '14'
};
const OPERATOR_DETECT_ORDER = [
  { code: '8', symbol: '>=' },
  { code: '9', symbol: '<=' },
  { code: '10', symbol: '!=' },
  { code: '5', symbol: '>' },
  { code: '7', symbol: '<' },
  { code: '6', symbol: '=' }
];

const createEmptyForm = () => ({
  companyId: '',
  groupId: '',
  targetCompanyId: '',
  targetGroupId: '',
  targetUserId: '',
  urgeStatus: [],
  caseStatus: [],
  selfContactStatus: [],
  startCreateTime: '',
  endCreateTime: '',
  timingTime: '',
  isOpen: true,
  holiday: [],
  paramKey: '',
  param: '',
  paramLogic: '',
  overdueDates: '',
  overdueAmount: '',
  overdueDatesLogic: '',
  overdueDatesValue: null,
  overdueDatesStart: null,
  overdueDatesEnd: null,
  overdueAmountLogic: '',
  overdueAmountValue: null,
  overdueAmountStart: null,
  overdueAmountEnd: null,
  operationLogic: ''
});

export default {
  data() {
    return {
      loading: false,
      list: [],
      search: {
        companyId: '',
        groupId: ''
      },
      dialogVisible: false,
      form: createEmptyForm(),
      companyList: [],
      groupList: [],
      targetGroupList: [],
      targetUserList: [],
      isEdit: false,
      urgeStatusOptions: [],
      selfContactStatusOptions: [],
      caseStatusOptions: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      rules: {
        companyId: [{ required: true, message: '请选择公司', trigger: 'change' }],
        groupId: [{ required: true, message: '请选择策略组', trigger: 'change' }],
        targetCompanyId: [{ required: true, message: '请选择跟进公司', trigger: 'change' }],
        urgeStatus: [{ type: 'array', required: true, message: '请选择催收状态', trigger: 'change' }],
        targetUserId: [{ required: true, message: '请选择目标用户', trigger: 'change' }],
        timingTime: [{ required: true, message: '请选择跟进时间', trigger: 'change' }]
      },
      searchCompanyList: [],
      searchGroupList: [],
      logicOptionsMap: {}
    };
  },
  computed: {
    numberLogicOptions() {
      return this.logicOptionsMap['2'] || [];
    },
    characterLogicOptions() {
      return this.logicOptionsMap['1'] || [];
    }
  },
  methods: {
    // 列表
    fetchList() {
      this.loading = true;
      this.$ajax({
        url: '/copyOfCollectionConfig/pageList',
        method: 'POST',
        data: {
          start: (this.currentPage - 1) * this.pageSize,
          limit: this.pageSize,
          companyId: this.search.companyId,
          groupId: this.search.groupId
        }
      }).then((res) => {
        const data = res.data.list || res.data || [];
        this.list = (data || []).map(it => ({
          ...it,
          urgeStatusText: this.mapUrgeStatus(it.urgeStatus),
          caseStatusText: this.mapCaseStatus(it.caseStatus),
          selfContactStatusText: this.mapSelfContactStatus(it.selfContactStatus),
          holidayText: this.mapHoliday(it.holiday),
          targetUserName: it.targetUserName || it.userName || ''
        }));
        this.total = res.data.totalRecords || 0;
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    handleSearch() {
      this.currentPage = 1;
      this.fetchList();
    },
    handleReset() {
      this.search.companyId = '';
      this.search.groupId = '';
      this.searchGroupList = [];
      this.currentPage = 1;
      this.fetchList();
    },
    handlePageChange(page) {
      this.currentPage = page;
      this.fetchList();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.fetchList();
    },
    handleAdd() {
      this.resetDialog();
      this.dialogVisible = true;
      this.isEdit = false;
      this.getCompanyList();
      this.loadDicts();
      this.loadLogicOptions(2);
      this.loadLogicOptions(1);
    },
    resetDialog() {
      this.form = createEmptyForm();
      this.groupList = [];
      this.targetGroupList = [];
      this.targetUserList = [];
      this.isEdit = false;
    },
    getCompanyList() {
      this.$ajax({ url: '/company/getAllValidCompany', method: 'GET' }).then((res) => {
        this.companyList = res.data || [];
      });
    },
    async onCompanyChange(val, groupId) {
      this.form.groupId = '';
      this.groupList = [];
      if (val) {
        const res = await this.$ajax({ url: `/strategy/list/${val}`, method: 'GET' });
        this.groupList = res.data || [];
        if (groupId) this.form.groupId = groupId;
      }
    },
    async onTargetCompanyChange(val, targetGroupId) {
      this.form.targetGroupId = '';
      this.targetGroupList = [];
      this.targetUserList = [];
      if (val) {
        const res = await this.$ajax({ url: `/strategy/list/${val}`, method: 'GET' });
        this.targetGroupList = res.data || [];
        if (targetGroupId) this.form.targetGroupId = targetGroupId;
        // 目标公司用户
        this.$ajax({ url: `/copyConfig/getAllUser/${val}`, method: 'GET' }).then((response) => {
          this.targetUserList = response.data || [];
        });
      }
    },
    // 保存
    handleDialogConfirm() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;
        const company = this.companyList.find(i => i.id === this.form.companyId);
        const group = this.groupList.find(i => i.id === this.form.groupId);
        const targetCompany = this.companyList.find(i => i.id === this.form.targetCompanyId);
        const targetGroup = this.targetGroupList.find(i => i.id === this.form.targetGroupId);
        // 处理 holiday：单选传数字，多选传逗号字符串
        const holidayPayload = this.formatHolidayPayload(this.form.holiday);
        const {
          overdueDatesLogic,
          overdueDatesValue,
          overdueDatesStart,
          overdueDatesEnd,
          overdueAmountLogic,
          overdueAmountValue,
          overdueAmountStart,
          overdueAmountEnd,
          caseStatus,
          urgeStatus,
          selfContactStatus,
          paramLogic,
          paramKey,
          param,
          ...restForm
        } = this.form;
        const datesValid = this.validateLogicValue('逾期天数', overdueDatesLogic, {
          value: overdueDatesValue,
          start: overdueDatesStart,
          end: overdueDatesEnd
        });
        const amountValid = this.validateLogicValue('逾期总额', overdueAmountLogic, {
          value: overdueAmountValue,
          start: overdueAmountStart,
          end: overdueAmountEnd
        });
        const paramValid = this.validateParamConfig(paramLogic, paramKey, param);
        if (!datesValid || !amountValid || !paramValid) return;
        const overdueDatesPayload = this.buildValueForPayload(overdueDatesLogic, {
          value: overdueDatesValue,
          start: overdueDatesStart,
          end: overdueDatesEnd
        });
        const overdueAmountPayload = this.buildValueForPayload(overdueAmountLogic, {
          value: overdueAmountValue,
          start: overdueAmountStart,
          end: overdueAmountEnd
        });
        const operationLogic = this.buildOperationLogicString(overdueDatesLogic, overdueAmountLogic, paramLogic);
        const paramPayload = this.buildParamPayload(paramLogic, paramKey, param);
        const caseStatusPayload = this.formatMultiSelectValue(caseStatus);
        const urgeStatusPayload = this.formatMultiSelectValue(urgeStatus);
        const selfContactStatusPayload = this.formatMultiSelectValue(selfContactStatus);
        const payload = {
          ...restForm,
          caseStatus: caseStatusPayload,
          urgeStatus: urgeStatusPayload,
          selfContactStatus: selfContactStatusPayload,
          overdueDates: overdueDatesPayload,
          overdueAmount: overdueAmountPayload,
          operationLogic,
          param: paramPayload,
          holiday: holidayPayload,
          companyName: company ? company.companyName : '',
          groupName: group ? group.groupName : '',
          targetCompanyName: targetCompany ? targetCompany.companyName : '',
          targetGroupName: targetGroup ? targetGroup.groupName : ''
        };
        const url = '/copyOfCollectionConfig/addOrUpdateConfig';
        this.$ajax({ url, method: 'POST', data: payload }).then(() => {
          this.$message.success(this.isEdit ? '修改成功' : '添加成功');
          this.dialogVisible = false;
          this.resetDialog();
          this.fetchList();
        });
      });
    },
    async handleEdit(row) {
      this.dialogVisible = true;
      this.isEdit = true;
      let holidayValue = [];
      if (Array.isArray(row.holiday)) {
        holidayValue = row.holiday;
      } else if (row.holiday === '' || row.holiday === null || row.holiday === undefined) {
        holidayValue = [];
      } else {
        holidayValue = String(row.holiday).split(',').map(n => Number(n));
      }
      const { overdueDatesLogic, overdueAmountLogic, paramLogic } = this.splitOperationLogic(row.operationLogic);
      await this.loadLogicOptions(2);
      await this.loadLogicOptions(1);
      const overdueDatesState = this.resolveFieldState(overdueDatesLogic, row.overdueDates);
      const overdueAmountState = this.resolveFieldState(overdueAmountLogic, row.overdueAmount);
      const parsedParam = this.parseParamField(row.param, paramLogic);
      this.form = {
        ...createEmptyForm(),
        ...row,
        holiday: holidayValue,
        caseStatus: this.parseMultiSelectField(row.caseStatus),
        urgeStatus: this.parseMultiSelectField(row.urgeStatus),
        selfContactStatus: this.parseMultiSelectField(row.selfContactStatus),
        paramKey: parsedParam.key,
        param: parsedParam.value,
        paramLogic,
        overdueDatesLogic: overdueDatesState.logic,
        overdueDatesValue: overdueDatesState.value,
        overdueDatesStart: overdueDatesState.start,
        overdueDatesEnd: overdueDatesState.end,
        overdueAmountLogic: overdueAmountState.logic,
        overdueAmountValue: overdueAmountState.value,
        overdueAmountStart: overdueAmountState.start,
        overdueAmountEnd: overdueAmountState.end,
        timingTime: this.formatTimeForPicker(row.timingTime),
        startCreateTime: this.formatTimeForPicker(row.startCreateTime),
        endCreateTime: this.formatTimeForPicker(row.endCreateTime)
      };
      await this.getCompanyList();
      await this.onCompanyChange(row.companyId, row.groupId);
      await this.onTargetCompanyChange(row.targetCompanyId, row.targetGroupId);
      // 新增：拉取目标公司用户列表（编辑时）
      if (row.targetCompanyId) {
        this.$ajax({ url: `/copyConfig/getAllUser/${row.targetCompanyId}`, method: 'GET' }).then((res) => {
          this.targetUserList = res.data || [];
        });
      }
      this.loadDicts();
    },
    handleDelete(row) {
      this.$confirm('确定要删除该配置吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax({ url: `/copyOfCollectionConfig/deleteConfig/${row.id}`, method: 'DELETE' }).then(() => {
          this.$message.success('删除成功');
          const totalAfterDelete = this.total - 1;
          const maxPage = Math.ceil(totalAfterDelete / this.pageSize) || 1;
          if (this.currentPage > maxPage) this.currentPage = maxPage;
          this.fetchList();
        });
      }).catch(() => {});
    },
    handleStatusChange(row, val) {
      // 处理 holiday 字段
      const holidayPayload = this.formatHolidayPayload(row.holiday);
      const data = { ...row, isOpen: val, holiday: holidayPayload };
      this.$ajax({ url: '/copyOfCollectionConfig/addOrUpdateConfig', method: 'POST', data }).then(() => {
        this.$message.success('状态更新成功');
        this.fetchList();
      }).catch(() => {
        this.$message.error('状态更新失败');
        row.isOpen = !val;
      });
    },
    // 搜索下拉
    getSearchCompanyList() {
      this.$ajax({ url: '/company/getAllValidCompany', method: 'GET' }).then((res) => {
        this.searchCompanyList = res.data || [];
      });
    },
    onSearchCompanyChange(val) {
      this.search.groupId = '';
      this.searchGroupList = [];
      if (val) {
        this.$ajax({ url: `/strategy/list/${val}`, method: 'GET' }).then((res) => {
          this.searchGroupList = res.data || [];
        });
      }
    },
    loadDicts() {
      this.urgeStatusOptions = [
        { value: '0', label: '未催收' },
        { value: '1', label: '催收中' },
        { value: '-1', label: '暂停催收' },
        { value: '2', label: '催收完成' }
      ];
      // 本人联系状态
      const p1 = this.$ajax({
        method: 'GET',
        url: '/dict/getList/benrendianhuaContactStatus',
        params: { 'val': '' }
      }).then((res) => {
        const selfContactStatusList = (res.data || []).map(item => ({
          ...item,
          title: item.modelName,
          value: item.modelCode,
          label: item.modelName
        }));
        this.selfContactStatusOptions = selfContactStatusList;
      });
      // 案件状态
      const p2 = this.$ajax({
        method: 'GET',
        url: '/dict/getList/caseStatus',
        params: { 'val': '' }
      }).then((res) => {
        const caseStatusList = (res.data || []).map(item => ({
          ...item,
          title: item.modelName,
          value: item.modelCode,
          label: item.modelName
        }));
        this.caseStatusOptions = caseStatusList;
      });
      return Promise.all([p1, p2]);
    },
    loadLogicOptions(type = 2) {
      const key = String(type);
      if (this.logicOptionsMap[key]) return Promise.resolve(this.logicOptionsMap[key]);
      return this.$ajax({ url: `/copyOfCollectionConfig/getLogic/${type}`, method: 'POST' }).then((res) => {
        const options = (res.data || []).map(item => ({
          ...item,
          code: String(item.code),
          label: item.desc || item.name || item.label || ''
        }));
        this.$set(this.logicOptionsMap, key, options);
        return options;
      }).catch(() => {
        this.$set(this.logicOptionsMap, key, []);
        return [];
      });
    },
    formatHolidayPayload(value) {
      if (!Array.isArray(value)) return value;
      if (value.length <= 1) {
        return value.length ? Number(value[0]) : '';
      }
      return value.join(',');
    },
    formatMultiSelectValue(value) {
      if (Array.isArray(value)) {
        return value.length ? value.join(',') : '';
      }
      if (value === undefined || value === null || value === '') return '';
      return String(value);
    },
    parseMultiSelectField(value) {
      if (Array.isArray(value)) return value;
      if (value === undefined || value === null || value === '') return [];
      return String(value).split(',').map(item => item.trim()).filter(item => item);
    },
    getLogicLabelByCode(type, code) {
      if (!code) return '';
      const key = String(type);
      const list = this.logicOptionsMap[key] || [];
      const found = list.find(item => String(item.code) === String(code));
      return found ? found.label : '';
    },
    handleLogicChange(fieldKey, logicCode) {
      const valueKey = `${fieldKey}Value`;
      const startKey = `${fieldKey}Start`;
      const endKey = `${fieldKey}End`;
      if (!logicCode) {
        this.form[valueKey] = null;
        this.form[startKey] = null;
        this.form[endKey] = null;
        return;
      }
      if (this.isRangeLogic(logicCode)) {
        this.form[valueKey] = null;
      } else {
        this.form[startKey] = null;
        this.form[endKey] = null;
      }
    },
    handleParamLogicChange(logicCode) {
      if (!logicCode) {
        this.form.param = '';
      }
    },
    buildParamPayload(logicCode, key, value) {
      if (!logicCode || !key) return '';
      if (value === undefined || value === null || String(value).trim() === '') return '';
      let logicLabel = this.getLogicLabelByCode(1, logicCode);
      // 去掉“字符”两个字，只保留关系词，比如“等于”“不等于”
      if (logicLabel) {
        logicLabel = logicLabel.replace(/^字符/, '');
      }
      return `${key}${logicLabel || ''}${value}`;
    },
    buildValueForPayload(logicCode, { value, start, end }) {
      if (!logicCode) return '';
      const logicKey = String(logicCode);
      if (this.isRangeLogic(logicKey)) {
        const brackets = RANGE_LOGIC_BRACKETS_MAP[logicKey] || ['[', ')'];
        const normalizedStart = this.normalizeNumber(start);
        const normalizedEnd = this.normalizeNumber(end);
        if (normalizedStart === null && normalizedEnd === null) return '';
        const startText = normalizedStart === null ? '' : normalizedStart;
        const endText = normalizedEnd === null ? '' : normalizedEnd;
        return `${brackets[0]}${startText},${endText}${brackets[1]}`;
      }
      if (!this.isSingleValueLogic(logicKey)) return '';
      const normalizedValue = this.normalizeNumber(value);
      if (normalizedValue === null) return '';
      const operator = SINGLE_VALUE_LOGIC_OPERATOR_MAP[logicKey] || '';
      return `${operator}${normalizedValue}`;
    },
    buildOperationLogicString(datesLogic, amountLogic, paramLogic) {
      const left = datesLogic ? String(datesLogic) : '';
      const middle = amountLogic ? String(amountLogic) : '';
      const right = paramLogic ? String(paramLogic) : '';
      if (!left && !middle && !right) return '';
      return `${left}_${middle}_${right}`;
    },
    resolveFieldState(initialLogic, storedValue) {
      const detectedLogic = initialLogic || this.detectLogicFromValue(storedValue);
      if (!detectedLogic) {
        return { logic: '', value: null, start: null, end: null };
      }
      const logic = String(detectedLogic);
      if (this.isRangeLogic(logic)) {
        const { start, end } = this.extractRangeValues(storedValue);
        return { logic, value: null, start, end };
      }
      if (this.isSingleValueLogic(logic)) {
        const operator = SINGLE_VALUE_LOGIC_OPERATOR_MAP[logic] || '';
        let raw = storedValue === undefined || storedValue === null ? '' : String(storedValue).trim();
        if (operator && raw.startsWith(operator)) raw = raw.slice(operator.length);
        return { logic, value: this.normalizeNumber(raw), start: null, end: null };
      }
      return { logic: '', value: null, start: null, end: null };
    },
    parseParamField(storedParam, paramLogic) {
      if (storedParam === undefined || storedParam === null) {
        return { key: '', value: '' };
      }
      const str = String(storedParam).trim();
      if (!str) return { key: '', value: '' };
      const keyMatch = str.match(/^(param\d+)/);
      if (keyMatch) {
        const key = keyMatch[1];
        let rest = str.slice(key.length);
        let logicLabel = paramLogic ? this.getLogicLabelByCode(1, paramLogic) : '';
        if (logicLabel) {
          logicLabel = logicLabel.replace(/^字符/, '');
        }
        if (logicLabel && rest.startsWith(logicLabel)) {
          rest = rest.slice(logicLabel.length);
        }
        return { key, value: rest };
      }
      return { key: '', value: str };
    },
    splitOperationLogic(operationLogic) {
      if (!operationLogic) return { overdueDatesLogic: '', overdueAmountLogic: '', paramLogic: '' };
      const parts = String(operationLogic).split('_');
      return {
        overdueDatesLogic: parts[0] ? String(parts[0]) : '',
        overdueAmountLogic: parts[1] ? String(parts[1]) : '',
        paramLogic: parts[2] ? String(parts[2]) : ''
      };
    },
    detectLogicFromValue(val) {
      if (val === undefined || val === null) return '';
      const str = String(val).trim();
      if (!str) return '';
      const bracketKey = `${str.charAt(0)}${str.charAt(str.length - 1)}`;
      if (BRACKETS_TO_LOGIC[bracketKey]) return BRACKETS_TO_LOGIC[bracketKey];
      for (let i = 0; i < OPERATOR_DETECT_ORDER.length; i += 1) {
        const item = OPERATOR_DETECT_ORDER[i];
        if (str.startsWith(item.symbol)) return item.code;
      }
      if (!Number.isNaN(Number(str))) return '6';
      if (str.includes('-')) return '14';
      return '';
    },
    extractRangeValues(val) {
      if (val === undefined || val === null) return { start: null, end: null };
      let str = String(val).trim();
      if (!str) return { start: null, end: null };
      if (/^[[(]/.test(str) && /[)\]]$/.test(str)) {
        str = str.slice(1, -1);
      }
      const separator = str.includes(',') ? ',' : '-';
      const [rawStart, rawEnd] = str.split(separator);
      return {
        start: this.normalizeNumber(rawStart === undefined ? '' : rawStart.trim()),
        end: this.normalizeNumber(rawEnd === undefined ? '' : rawEnd.trim())
      };
    },
    isRangeLogic(logicCode) {
      return Object.prototype.hasOwnProperty.call(RANGE_LOGIC_BRACKETS_MAP, String(logicCode || ''));
    },
    isSingleValueLogic(logicCode) {
      return Object.prototype.hasOwnProperty.call(SINGLE_VALUE_LOGIC_OPERATOR_MAP, String(logicCode || ''));
    },
    normalizeNumber(numberLike) {
      if (numberLike === '' || numberLike === null || numberLike === undefined) return null;
      const parsed = Number(numberLike);
      return Number.isNaN(parsed) ? null : parsed;
    },
    validateLogicValue(label, logicCode, { value, start, end }) {
      if (!logicCode) return true;
      if (this.isRangeLogic(logicCode)) {
        if ((start === null || start === undefined) && (end === null || end === undefined)) {
          this.$message.warning(`${label}请选择区间的起始或结束值`);
          return false;
        }
        return true;
      }
      if (value === null || value === undefined) {
        this.$message.warning(`${label}请输入数值`);
        return false;
      }
      return true;
    },
    validateTextLogicValue(label, logicCode, value) {
      if (!logicCode) return true;
      if (value === undefined || value === null || String(value).trim() === '') {
        this.$message.warning(`${label}请输入内容`);
        return false;
      }
      return true;
    },
    validateParamConfig(logicCode, key, value) {
      if (!logicCode && !key && (value === undefined || value === null || String(value).trim() === '')) {
        // 完全没配参数，视为通过
        return true;
      }
      if (!key) {
        this.$message.warning('请选择参数');
        return false;
      }
      if (!logicCode) {
        this.$message.warning('请选择参数逻辑');
        return false;
      }
      if (value === undefined || value === null || String(value).trim() === '') {
        this.$message.warning('请输入参数内容');
        return false;
      }
      return true;
    },
    mapSelfContactStatus(v) {
      const values = this.parseMultiSelectField(v);
      if (!values.length) return '';
      return values.map((val) => {
        const statusItem = this.selfContactStatusOptions.find(item => item.modelCode === val || String(item.modelCode) === String(val));
        return statusItem ? statusItem.modelName : '';
      }).filter(Boolean).join('、');
    },
    mapCaseStatus(v) {
      const values = this.parseMultiSelectField(v);
      if (!values.length) return '';
      return values.map((val) => {
        const statusItem = this.caseStatusOptions.find(item => item.modelCode === val || String(item.modelCode) === String(val));
        return statusItem ? statusItem.modelName : '';
      }).filter(Boolean).join('、');
    },
    mapUrgeStatus(v) {
      const values = this.parseMultiSelectField(v);
      if (!values.length) return '';
      return values.map((val) => {
        const statusItem = this.urgeStatusOptions.find((item) => {
          if (item.value === val) return true;
          if (String(item.value) === String(val)) return true;
          return false;
        });
        return statusItem ? statusItem.label : '';
      }).filter(Boolean).join('、');
    },
    mapHoliday(v) {
      let arr = [];
      if (Array.isArray(v)) {
        arr = v;
      } else if (v === '' || v === null || v === undefined) {
        arr = [];
      } else {
        arr = String(v).split(',').map(n => Number(n));
      }
      const map = { 0: '工作日', 1: '周末', 2: '节假日' };
      return arr.map(n => map[n]).filter(Boolean).join('、');
    },
    formatCreateRange(s, e) {
      if (!s && !e) return '';
      return `${s || ''}${s || e ? ' - ' : ''}${e || ''}`;
    },
    formatTimeForPicker(timeValue) {
      if (!timeValue || timeValue === null || timeValue === undefined || timeValue === '') {
        return '';
      }
      const timeStr = String(timeValue).trim();
      if (!timeStr) return '';
      // 如果已经是 HH:mm:ss 格式，直接返回
      if (/^\d{2}:\d{2}:\d{2}$/.test(timeStr)) {
        return timeStr;
      }
      // 如果是 HH:mm 格式，补充秒数
      if (/^\d{2}:\d{2}$/.test(timeStr)) {
        return `${timeStr}:00`;
      }
      // 如果包含日期时间，提取时间部分
      const dateTimeMatch = timeStr.match(/(\d{2}:\d{2}:\d{2})/);
      if (dateTimeMatch) {
        return dateTimeMatch[1];
      }
      // 如果包含日期时间但只有时分，提取并补充秒数
      const timeOnlyMatch = timeStr.match(/(\d{2}:\d{2})/);
      if (timeOnlyMatch) {
        return `${timeOnlyMatch[1]}:00`;
      }
      return '';
    },
    headerCellStyle() {
      return { background: '#eef3ff', color: '#333', fontWeight: 'normal', textAlign: 'center' };
    },
    cellStyle() {
      return { textAlign: 'center' };
    }
  },
  async mounted() {
    await Promise.all([this.loadDicts(), this.loadLogicOptions(2), this.loadLogicOptions(1)]);
    this.fetchList();
    this.getSearchCompanyList();
  }
};
</script>
<style scoped>
.page-bg {
  background: #f5f7fa;
  min-height: 100vh;
  padding: 24px;
}
.card {
  background: #fff;
  border-radius: 0;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.05);
  margin-bottom: 24px;
  padding: 24px;
}
.search-card {
  margin-bottom: 16px;
}
.table-card {
  padding-top: 16px;
}
.table-header {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 10px;
}
.center-dialog >>> .el-dialog__header { text-align: center; }
.dialog-footer-center { display: flex; justify-content: center; gap: 16px; }
.range-input {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.double-field {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}
.flex-form-item {
  flex: 1;
}
.param-inline .el-select,
.param-inline .el-input {
  width: 150px;
}
.param-inline .el-input {
  flex: 1;
  min-width: 180px;
}
.range-separator {
  color: #666;
  font-size: 12px;
}
</style>




// WEBPACK FOOTER //
// src/page/main/system/collectConfig.vue